import { useFormik } from "formik";
import RiskLessonTaskModalUI from "./RiskLessonTaskModalUI";
import ShortTextInput from "../Inputs/ShortTextInput";
import TextAreaInput from "../Inputs/TextAreaInput";
import CustomAvatar from "../ui/CustomAvatar";
import { showToast } from "../../utils/toastUtils";
import { createLesson, deleteLesson } from "../../api/Api";
import { lessonValidationSchema } from "../../utils/validations";
import he from 'he';

function LessonTaskModal({ show, handleClose,task_id, fetchLessons, lessons }){
  const formik = useFormik({
    initialValues: {
      title: "",
      task_id: task_id? task_id : "" || null,
      description: "",
    },
    validationSchema: lessonValidationSchema,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      setSubmitting(true);
      try {
        const response = await createLesson(values);
        if (response.status === 201) {
          showToast("Lesson added successfully", "success");
          resetForm();
          fetchLessons();
        } else {
          showToast("Failed to add lesson", "error");
        }
      } catch (error) {
        showToast("Error adding lesson", "error");
      } finally {
        setSubmitting(false);
      }
    },
  });

  const handleDeleteLesson = async (id) => {
    try {
      const response = await deleteLesson(id);
      if (response.status === 200) {
        showToast("Lesson deleted successfully", "success");
        fetchLessons();
      } else {
        showToast("Failed to delete lesson", "error");
      }
    } catch (error) {
      showToast("Error deleting lesson", "error");
    }
  };

  const renderLessonItem = (lesson) => (
    <div className="d-flex align-items-top">
      <CustomAvatar user={lesson.created_by} size="35px" fontSize={20} />
      <div className="ms-3">
        <h6>{lesson.title}</h6>
        <p className="text-muted" style={{ fontSize: "14px" }}>
          {new Date(lesson.created_at).toLocaleString()}
        </p>
        <p>{he.decode(lesson.description.replace(/<[^>]+>/g, ""))}</p>
      </div>
    </div>
  );

  return (
    <RiskLessonTaskModalUI
      show={show}
      handleClose={handleClose}
      title="Lessons"
      formFields={
        <>
          <ShortTextInput
            label="Title"
            id="title"
            name="title"
            required
            value={formik.values.title}
            onChange={formik.handleChange}
            placeholder="Enter lesson title"
            error={formik.touched.title && formik.errors.title}
          />
          <TextAreaInput
            label="Description"
            id="description"
            name="description"
            required
            placeholder="Enter lesson description"
            value={formik.values.description}
            onChange={formik.handleChange}
            error={formik.touched.description && formik.errors.description}
          />
        </>
      }
      onSubmit={formik.handleSubmit}
      submitting={formik.isSubmitting}
      submitLabel="Add Lesson"
      list={lessons}
      loading={false}
      onDelete={handleDeleteLesson}
      renderItem={renderLessonItem}
      emptyMessage="No lessons to display. Please add one."
    />
  );
}

export default LessonTaskModal;
